// extracted by mini-css-extract-plugin
export default {"teacher":"Teacher_teacher__9TNHO","title":"Teacher_title__pYXvi","search":"Teacher_search__RkBhr"};